module.exports = __webpack_public_path__ + "static/media/checked.e5d924ce.png";